/**
 * Utilities for parsing Google Drive URLs
 */

/**
 * Extract the file/folder ID from a Google Drive URL.
 * If the input is not a valid URL, returns the input as-is (assumes it's already an ID).
 *
 * Handles URL formats like:
 * - https://drive.google.com/drive/folders/<ID>
 * - https://drive.google.com/file/d/<ID>/view
 * - https://docs.google.com/document/d/<ID>/edit
 * - https://docs.google.com/spreadsheets/d/<ID>/edit
 */
export function getGoogleDriveFolderId(stringURL: string): string {
  try {
    const url = new URL(stringURL)
    // Files/docs/sheets: .../d/<ID>/...
    const match = url.pathname.match(/\/d\/([\w-]+)/)
    if (match) return match[1]
    // Folders: .../folders/<ID>
    const folderMatch = url.pathname.match(/folders\/([\w-]+)/)
    if (folderMatch) return folderMatch[1]
    return ''
  } catch {
    return stringURL
  }
}
